module.exports = __webpack_public_path__ + "static/allizLogo-d97031c0a95af50dccbebb14c782e51b.svg";